<template>
	<div id="app">
		<router-view />
		<!-- <Loading v-if="showLoading"></Loading> -->
		<!-- <router-view v-if="isRouterAlive"></router-view> -->
	</div>
</template>

<script>
// import Loading from '@/components/Loading.vue'


export default {
	name: 'App',
	components: {

	},
	data() {
		return {
		}
	},
	created(){
		console.log('created------',process.env.NODE_ENV)
	},
	mounted(){
		if (this._isMobile()) {
			console.log("手机端");
			console.log(this.$route.query)
			console.log(this.$router);
			this.$router.push({
				name:'mIndex',
				query:{ cid: this.$route.query.cid}
			});
		} else {
			console.log("pc端");
			// this.$router.replace('Index');
			this.$router.push({
				name:'Index',
				query:{ cid: this.$route.query.cid}
			});
		}
	},
	methods: {
		_isMobile() {
			let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
			return flag;
		}
	}

}
</script>

<style lang="scss" scoped>
@import '@/assets/css/common.scss';
#app {
	height: 100%;
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue